/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from 'react'
import ScrollProvider from './src/contexts/ScrollContext'
import GuidelineProvider from './src/contexts/GuidelineContext'
import PopupProvider from './src/contexts/PopupContext'
import OverlayProvider from './src/contexts/OverlayContext'
import HealthPointServiceProvider from './src/contexts/HealthPointServiceContext'
import UnsupportedBrowserMessage from './src/components/common/UnsupportedBrowserMessage'
import GlobalInfoBanners from './src/components/common/GlobalInfoBanners'
// import "core-js/stable";
// import "regenerator-runtime/runtime";
// import 'formdata-polyfill'

export const onRouteUpdate = ({ location, prevLocation }) => {
  // Check if the page exists in Gatsby's internal routing
  if (window && !window.__GATSBY?.page && (location?.hostname === 'localhost' || location?.hostname === 'starship.org.nz')) { 
    console.log('Fire to NR Bare')
    window.newrelic.setCustomAttribute('BareDomainNavigation', 'bare', true)
  } else {
    console.log('No Bare Domain Navigation')
    window.newrelic.setCustomAttribute('BareDomainNavigation', 'www', true)
  }
    
}
export const wrapRootElement = ({ element }) => {
    return (
        <OverlayProvider>
            <PopupProvider>
                <GuidelineProvider>
                    <HealthPointServiceProvider>
                        <ScrollProvider>
                            <UnsupportedBrowserMessage />
                            <GlobalInfoBanners />
                            {element}
                        </ScrollProvider>
                    </HealthPointServiceProvider>
                </GuidelineProvider>
            </PopupProvider>
        </OverlayProvider>
    )
}

export const onClientEntry = () => {
    // Ensure gtag is available
    if (typeof window !== 'undefined') {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
            window.dataLayer.push(arguments);
        }
        window.gtag = gtag;
    }
};
